import styled, { css } from 'styled-components';
import { Row } from '../../styled';
import { ellipsisStyle } from '../../styled/mixins';
import { contentWidthMedia } from '../../styled/utils';
import { contentBreakpoints } from 'constants/breakpoints';
import {
    EventColMeta,
    EventMainMarkets,
} from '../../containers/EventListItemContainers/styled';

export const ViewEventListHeader = styled(Row)`
    gap: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};
    background-color: ${({ theme }) => theme.bg.neutralGrey};
    border-top: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    border-bottom: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    padding: ${({ $isMobile }) =>
        $isMobile ? '4px 8px 4px 4px' : '4px 16px 4px 0'};
    box-sizing: border-box;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.1px;

    ${({ $contentWidth }) => {
        const media = contentWidthMedia($contentWidth);

        return css`
            ${media.lessThan(
                contentBreakpoints.LG,
                css`
                    max-width: 315px;
                `
            )};
        `;
    }};
`;

export const ViewEventListHeaderSubTitle = styled(EventColMeta)`
    padding-left: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};

    span {
        ${ellipsisStyle};
    }
`;

export const FlexSubheaderWrapper = styled(EventMainMarkets)`
    display: flex;

    & > div {
        text-align: center;
        flex: 1;
    }
`;

export const SubheaderRow = styled(Row)`
    flex-direction: row;
    gap: 4px;
    text-align: center;
`;
export const SubheaderRowReverse = styled(SubheaderRow)`
    flex-direction: row-reverse;
`;
